const status = {
  IN_FUTURE: "inFuture",
  NOT_AVALIABLE: "",
  TO_REVIEW: "toReview",
};

export default status;
